import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import "./page-alert.scss";

const icons = {
  success: "ph:check-circle",
  error: "ph:warning-circle",
};

const PageAlert = ({ variant = "error", children, onDismiss }) => {
  if (!children) return null;

  return (
    <div className={`page-alert page-alert--${variant}`} role={variant === "error" ? "alert" : "status"}>
      <span className="page-alert__content">
        <Icon icon={icons[variant] || icons.error} height={16} aria-hidden="true" />
        <span>{children}</span>
      </span>
      {onDismiss ? (
        <button type="button" onClick={onDismiss} aria-label="Dismiss">
          <Icon icon="ph:x" height={14} />
        </button>
      ) : null}
    </div>
  );
};

export default PageAlert;
